import { Button } from '@evogard/ui';
import type { Money } from '@evogard/domain';
import type { FinanceDashboardRowWire } from '@evogard/contract';
import { money } from './money.js';

/** O que um corte mede: a receita ou a despesa. O saldo fica no mapa e nos totais. */
export type Measure = 'receitas' | 'despesas';

// @valor
export const MEASURE_LABELS: Readonly<Record<Measure, string>> = {
  receitas: 'Receitas',
  despesas: 'Despesas',
};

export const valueOf = (row: FinanceDashboardRowWire, measure: Measure): Money =>
  money(measure === 'receitas' ? row.revenue.amount : row.expense.amount);

/** A chave Receitas / Despesas do cabeçalho do cartão — o mesmo desenho da chave do mapa. */
export function MeasureToggle({
  value,
  onChange,
}: {
  value: Measure;
  onChange: (measure: Measure) => void;
}) {
  return (
    <div className="flex items-center gap-1">
      {(['receitas', 'despesas'] as const).map((m) => (
        <Button
          key={m}
          variant={value === m ? 'secundario' : 'discreto'}
          size="sm"
          aria-pressed={value === m}
          onClick={() => onChange(m)}
        >
          {MEASURE_LABELS[m]}
        </Button>
      ))}
    </div>
  );
}
